import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_input_form = _resolveComponent("search-input-form")!

  return (_openBlock(), _createBlock(_component_search_input_form, {
    ref: "formRef",
    "info-label": _ctx.localize('LoadDeviceData'),
    placeholder: _ctx.localize('EnterSerialNo'),
    onSearch: _ctx.findDevice
  }, null, 8, ["info-label", "placeholder", "onSearch"]))
}